var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trapezoid btn-like",style:(_vm.styleObj),on:{"mouseenter":function($event){_vm.isHover = true},"mouseleave":function($event){_vm.isHover = false}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }